export const patientTypes = [
  { label: 'Adult', value: 'Adult' },
  { label: 'Temp Adult', value: 'Temp Adult' },
  { label: 'Minor', value: 'Minor' },
  { label: 'Temp Minor', value: 'Temp Minor' },
  { label: 'Caregiver', value: 'Caregiver' },
  { label: 'Non Licenced', value: 'Non Licenced' },
  { label: 'Other', value: 'Other' }
]

// List of pricing item
export const pricingGroupTypes = [
  { pricing_name: '3.5g', weight_quantity: 3.5 },
  { pricing_name: '7g', weight_quantity: 7 },
  { pricing_name: '14g', weight_quantity: 14 },
  { pricing_name: '28g', weight_quantity: 28 }
]

export const taxMode = {
  taxIncluded: 'tax_included',
  taxNotIncluded: 'tax_not_included'
}
// List of dollar types
export const dollarTypes = [
  { cash: 'Hundreds', cashValue: 100 },
  { cash: 'Fifties', cashValue: 50 },
  { cash: 'Twenties', cashValue: 20 },
  { cash: 'Tens', cashValue: 10 },
  { cash: 'Fives', cashValue: 5 },
  { cash: 'Ones', cashValue: 1 },
  { cash: 'Twenty Five Cents', cashValue: 0.25 },
  { cash: 'Ten Cents', cashValue: 0.1 },
  { cash: 'Five Cents', cashValue: 0.05 },
  { cash: 'One Cents', cashValue: 0.01 }
]

// list of cash float status
export const cashFloatStatusTypes = [
  { label: 'Open', value: 'open' },
  { label: 'Close', value: 'close' }
]

export const locationTypes = [
  {
    label: 'Default',
    value: 'Default Location Type',
    isGrower: false
  },
  { label: 'Indoor', value: 'Indoor Grow', isGrower: true },
  { label: 'Outdoor', value: 'Outdoor Grow', isGrower: true }
]

// client role options
export const clientRoleOptions = [
  { label: 'Cultivator', value: 'Cultivator' },
  { label: 'Processor', value: 'Processor' },
  { label: 'Retailer', value: 'Retailer' },
  { label: 'Researcher', value: 'Researcher' },
  { label: 'Waste Disposal', value: 'Waste Disposal' },
  { label: 'Lab', value: 'Lab' },
  { label: 'Other', value: 'Other' }
]

// discount type options
export const discountTypeOptions = [
  {
    label: '$',
    value: 2
  },
  {
    label: '%',
    value: 1
  }
]

export const discountApplicableType = {
  preTax: 'preTax',
  postTax: 'postTax'
}

export const discountType = {
  percentage: 'percentage',
  dollar: 'dollar'
}

// discount on options
export const discountRule = {
  item: 'Item',
  category: 'Category',
  customer_birthDate: 'Customer Birthdate',
  customer_status: 'Customer Status',
  new_customer: 'New Customer'
}

// discount apply when - options
export const discountApplyWhen = {
  dateTime: 'Date Time',
  dayOfWeek: 'Day Of Week'
}

export const statusOptions = [
  { label: 'Veteran', value: 'Veteran' },
  { value: 'Veteran(Disabled)', label: 'Veteran(Disabled)' },
  { label: 'Govt.Employee', value: 'Govt.Employee' },
  { label: 'Other', value: 'Other' }
]

// batch status
export const BatchStatus = [
  { label: 'active', value: 'active' },
  { label: 'inactive', value: 'inactive' }
]

// growth phase
export const growthPhaseOptions = [
  { label: 'Seeds', value: 'Seeds' },
  { label: 'Immature', value: 'Immature' },
  { label: 'Vegetative', value: 'Vegetative' },
  { label: 'Flowering', value: 'Flowering' }
]

// list of applicable taxes on item
export const invoiceTaxTypes = [
  {
    taxName: 'Excise Tax',
    taxSlug: 'excise_tax',
    isTaxEnable: true,
    taxCount: 0
  },
  {
    taxName: 'State Tax',
    taxSlug: 'state_tax',
    isTaxEnable: true,
    taxCount: 0
  },
  {
    taxName: 'County Tax',
    taxSlug: 'county_tax',
    isTaxEnable: true,
    taxCount: 0
  },
  {
    taxName: 'City Tax',
    taxSlug: 'city_tax',
    isTaxEnable: true,
    taxCount: 0
  }
]

// list of batch lauout
export const batchLayouts = {
  list: 'List',
  grid: 'Grid'
}

// list of batch status
export const batchStatus = [
  { label: 'active', value: 'active' },
  { label: 'inactive', value: 'inactive' }
]

//transfer
export const transferStatus = {
  Approved: 'approved',
  Pending: 'pending'
}

// transfer type
export const transactionType = [
  { label: 'credit', value: 'Credit' },
  { label: 'debit', value: 'Debit' },
  { label: 'sale', value: 'Sale' },
  { label: 'return', value: 'Return' }
]

// adjustment reasons
export const adjustmentReasons = [
  {
    value: 'Contaminant Testing',
    label: 'Contaminant Testing'
  },
  {
    value: 'Damage/Spoilage',
    label: 'Damage/Spoilage'
  },
  {
    value: 'Drying',
    label: 'Drying'
  },
  {
    value: 'Mandatory State Destruction',
    label: 'Mandatory State Destruction'
  },
  {
    value: 'Potency Testing',
    label: 'Potency Testing'
  },
  {
    value: 'Scale Variance',
    label: 'Scale Variance'
  },
  {
    value: 'Theft',
    label: 'Theft'
  },
  {
    value: 'Typing/Entry Error',
    label: 'Typing/Entry Error'
  },
  {
    value: 'Purchased More',
    label: 'Purchased More'
  },
  {
    value: 'Other',
    label: 'Other'
  }
]
